"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoreDetails = exports.FreeCredit3 = exports.FreeCredit2 = exports.FreeCredit1 = exports.Introduction = exports.FreeCreditFeatures = exports.FreeCredit = exports.Block = exports.ButtonText = exports.BoxBottom = exports.BoxMain = exports.BoxHead = exports.Box = void 0;
const react_scroll_1 = require("react-scroll");
const styled_breakpoints_1 = require("styled-breakpoints");
const styled_components_1 = __importDefault(require("styled-components"));
exports.Box = styled_components_1.default.div `
	width: 100%;
	min-height: 500px;
	position: relative;
	background: ${props => props.theme.color.white};
	border-radius: 4px 4px 0 0;
	overflow: hidden;
	box-shadow: 0 15px 35px rgb(50 50 77 / 10%), 0 5px 15px rgb(0 0 0 / 7%);
	display: flex;
	flex-direction: column;

	${(0, styled_breakpoints_1.up)('md')} {
		border-radius: 4px 0 0 4px;
		top: 55px;
		width: 50%;
	}
`;
exports.BoxHead = styled_components_1.default.div `
	padding: 1.5em 3em 1.2em;
	text-align: center;
	border-bottom: 1px solid ${props => props.theme.color.gray2};

	font-weight: 400;
	font-size: 1.3em;
	color: ${props => props.theme.color.brand1};

	strong {
		font-weight: 700;
		text-transform: uppercase;
		color: ${props => props.theme.color.success};
	}
`;
exports.BoxMain = styled_components_1.default.div `
	flex-grow: 1;
`;
exports.BoxBottom = styled_components_1.default.div `
	padding: 0 0 1.8em;
	text-align: center;
	border-top: 1px solid ${props => props.theme.color.gray2};
	color: ${props => props.theme.color.brand1};
	display: flex;
	flex-direction: column;
	align-items: center;
`;
exports.ButtonText = styled_components_1.default.div ``;
exports.Block = styled_components_1.default.div `
	width: 100%;
`;
exports.FreeCredit = styled_components_1.default.div `
	width: 100%;
	padding: 0 0 2em 0;
	text-align: center;
`;
exports.FreeCreditFeatures = styled_components_1.default.div `
	text-align: left;
	width: 100%;
	display: flex;
	flex-direction: column;
	padding: 2em 3em 0;

	ul {
		width: 400px;
		max-width: 100%;
		margin: 0 auto;
		padding: 0 0 0 2.5em;
		color: ${props => props.theme.color.gray6};
		font-size: 1.2em;
	}
`;
exports.Introduction = styled_components_1.default.div `
	text-align: center;
	color: ${props => props.theme.color.gray6};
	font-size: 1.2em;
	padding: 2em 3em 2em;
`;
exports.FreeCredit1 = styled_components_1.default.div `
	width: 100%;
	padding: 0 3em;
	font-weight: 700;
`;
exports.FreeCredit2 = styled_components_1.default.div `
	font-size: 3em;
	font-weight: 700;
	padding: 0.3em 1em 0.4em;
	color: ${props => props.theme.color.brand3};
`;
exports.FreeCredit3 = styled_components_1.default.div `
	width: 100%;
	font-weight: 400;
	font-size: 0.9em;
	padding: 1em 3em 0;
	color: ${props => props.theme.color.gray6};
`;
exports.MoreDetails = (0, styled_components_1.default)(react_scroll_1.Link) `
	margin: 1em auto 0;
	display: inline-block;
	text-decoration: underline;
	color: ${props => props.theme.color.gray6};
	font-size: 1em;
`;
